export default {
  h1_services: "خدمات الذكاء الاصطناعي للأطباء",
  Services: "الخدمات",
  eduServices: "الدورات",
  AIServices: "الخدمات",
  mg: "تصوير الثدي الشعاعي",
  dx: "تصوير الصدر بالأشعة السينية و الفلوروجرافيا",
  "Go to service": "الانتقال إلى الخدمة",
  "Service banner text": "احسب تأثير إدخال الذكاء الاصطناعي في مؤسستك",
  Calc: "احسب",
  "Services title": "قائمة الخدمات | " + process.env.VUE_APP_INSTALL_NAME,
  "No description service": "لا يوجد وصف",
  "Services cannot loading": "الخدمة غير متاحة مؤقتًا. حاول لاحقًا",
  "Cash calc title": "حساب التوفير | " + process.env.VUE_APP_INSTALL_NAME,
  "Cash calc": "حساب التوفير",
  "Cash calc desc": "كم من الموارد يمكنك توفيره باستخدام الذكاء الاصطناعي",
  "Cash calc desc about":
    "أدخل بيانات مؤسستك. سيتم حذف البيانات بعد الخروج من الحاسبة.",
  "Average cash": "متوسط راتب طبيب الأشعة شهريًا",
  "Study calc count": "عدد الدراسات في مؤسستك شهريًا",
  mmg: "تصوير الثدي الشعاعي",
  ddx: "أشعة الصدر",
  ct: "التصوير المقطعي للصدر",
  "Start calc": "ابدأ الحساب",
  economy: "التوفير",
  rub: " روبل",
  "calc time": " ساعة",
  "Calc summary": "الإجمالي سنويًا",
  "Without AI": "بدون ذكاء اصطناعي",
  "With AI": "مع ذكاء اصطناعي",
  "Count calc short": "عدد ",
  "Calc in Year": " في السنة",
  "Calc item 1": "وصف <br /> دراسة واحدة، دقيقة",
  "Calc item 2": "تكلفة وصف <br />دراسة واحدة، روبل",
  "Calc item 3": "التكاليف <br />للوصف",
  "Calc item 4": "الوقت المطلوب <br />للوصف، ساعة",
  mmg__count: "تصوير الثدي",
  ddx__count: "أشعة/فلوروجرافيا",
  ct__count: "التصوير المقطعي",
  "Calc info": "منهجية الحساب",
};
